import { useState, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import TodoStateFunc from "@/pcomponents/common/content/todo/state/func/state_func";
import TodoInfoArrFunc from "@/pcomponents/common/content/todo/list/info_arr_func";
import { useSelector, useDispatch } from 'react-redux';
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import Style from "./css/style.module.css";
import TopDateArea from "./area/top_date";
import StuArea from "./area/stu_area";
import TodoArea from "./area/todo_area";
import TodoDailyCArea from "./area/todo_dailyc";
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import WriteTodoPopup from "@/pages/comp/plan/todo/popup/write";
import StuMapWritePopup from "@/pages/comp/plan/study/study_map/stu_map/popup/stu_map_list";
import LoadingComponent from "@/pcomponents/common/content/loading";
import TextBookUsePageArea from "./area/textbook_use_page";

function ViewTodoDaySortPopup(props: any) {
  let myProps = {
    list_opt: {},
    list: (inData: any) => { },
    closePopup: () => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const [infoArr, setInfoArr] = useState<any>([]);
  const [add_todo_arr, set_add_todo_arr] = useState<any>([]);
  const [stu_info, set_stu_info] = useState<any>({
    "a_seq": "",
    "a_user_name": myProps.list_opt["s_stu_user_name"],
    "a_school_name": "",
    "a_stu_grade": "",
  });
  const [list_opt, set_list_opt] = useState({
    "s_stu_user_name": "",
    "s_stu_user_seq": "",
    "s_start_date": "",
    "s_end_date": "",
    "s_subject": "",
    ...myProps.list_opt
  });

  const [loading_data, set_loading_data] = useState({
    is_display: false,
    text: "저장 되었습니다.",
  });

  useEffect(() => {
    list({});
  }, []);

  const [popupData, setPopupData] = useState<any>({
    isOpen: false,
    sort: "todo_day_sort",//stu_map_list
    rowData: {},
    isUpdate: false,
    select_stu_name: "",
    select_stu_seq: "",
    select_date: "",
    receive_arr: [],
    attend_sort: "in",//in,out
    attend_sort_detail: "",
    user_info_arr: [],
    todo_info: {},
    todo_sort: "study",
    title: "맞춤플랜 보기",
    width: "500px",
    height: "100%",
  });

  const openTodoWriteOnePopup = (inData: any) => {
    let opt_obj = {
      select_date: list_opt.s_start_date,
      select_stu_name: "",
      select_stu_seq: "",
      todo_info: {},
      todo_sort: "study",
      isUpdate: true,
      ...inData
    };
    if (opt_obj["isUpdate"]) {
      if (strFunc.is_empty(opt_obj["todo_info"]["a_seq"])) {
        alert("내용 없음.");
        return false;
      }
    } else {
      opt_obj["todo_info"]["a_subject"] = list_opt.s_subject;
    }
    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "todo_write_one",
      select_stu_name: opt_obj["select_stu_name"],
      select_stu_seq: opt_obj["select_stu_seq"],
      select_date: opt_obj["select_date"],
      todo_sort: opt_obj["todo_sort"],
      todo_info: opt_obj["todo_info"],
      isUpdate: opt_obj["isUpdate"],
      title: "맞춤플랜",
      ...opt_obj
    });
  };

  const open_stu_map_list_popup = () => {
    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "stu_map_list",
      title: "교과맵핑",
      width: "800px",
      height: "100%",
    });
  };

  const list = (inData: any) => {
    let tmp_list_opt = {
      ...list_opt,
      ...inData,
    };
    
    set_list_opt(tmp_list_opt);
    let list_form_json: any = {
      "s_addon_user": "1",
      "s_is_mcomp_public": "1",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
      "order_id": "a_subject_name, a_ymd, a_seq",
      "s_reserve_start_date": tmp_list_opt["s_start_date"],
      "s_reserve_end_date": tmp_list_opt["s_start_date"],
      "s_stu_user_seq": tmp_list_opt.s_stu_user_seq,
      "s_addon_par_content": "1",
      "s_addon_elapse_time": "1",
      "s_addon_file_arr": "1",
      ...tmp_list_opt,
    };

    list_form_json.s_stu_mcomp_seq = user.comp_seq;

    if (strFunc.is_empty(list_form_json.s_stu_user_seq)) {
      return false;
    }
    if (strFunc.is_empty(list_form_json.s_start_date)) {
      return false;
    }
    if (strFunc.is_empty(list_form_json.s_stu_mcomp_seq)) {
      return false;
    }
    get_stu_info_by_ajax(tmp_list_opt);

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/todo/todo/list', list_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
        } else {
          alert("검색 중 오류.");
          props.closePopup();
        }
      });
  };

  const get_stu_info_by_ajax = (tmp_list_opt: any) => {
    let list_form_json = {
      "s_seq": [tmp_list_opt["s_stu_user_seq"]],
      "s_addon_home_work_file": "1",
      "s_addon_home_work_file_start_date": tmp_list_opt["s_start_date"],
      "s_addon_home_work_file_end_date": tmp_list_opt["s_start_date"],
      "s_addon_home_work_file_subject": tmp_list_opt["s_subject"],
      s_addon_plan_study_file: "1",
      s_addon_plan_study_file_start_date: tmp_list_opt["s_start_date"],
      s_addon_plan_study_file_end_date: tmp_list_opt["s_start_date"],
      s_addon_plan_study_file_subject: tmp_list_opt["s_subject"],
      s_addon_daily_report_last: "1",
      s_addon_daily_report: "1",
      s_addon_daily_report_start_date: tmp_list_opt["s_start_date"],
      s_addon_daily_report_end_date: tmp_list_opt["s_start_date"],
      s_addon_todo_dailyc: "1",
      s_addon_todo_dailyc_start_date: tmp_list_opt["s_start_date"],
      s_addon_todo_dailyc_end_date: tmp_list_opt["s_start_date"],
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    if (strFunc.is_empty(tmp_list_opt["s_stu_user_seq"])) {
      return false;
    }
    if (strFunc.is_empty(list_form_json["s_seq"])) {
      return false;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list', list_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            set_stu_info(response.data["data"]["info_arr"][0]);
          } else {
            alert("학생 검색결과 없음.");
            props.closePopup();
          }
        } else {
          alert("학생 검색 중 오류.");
          props.closePopup();
        }
      });
  };

  const on_change_todo = (inData: any) => {
    let opt_obj = {
      "value": "",
      "name": "",
      "todo_pri_val": "",
      ...inData
    };
    let name = opt_obj["name"];
    let value = opt_obj["value"];

    let tmp_info_arr = [...infoArr];
    let info_arr_len = tmp_info_arr.length;
    for (let i = 0; i < info_arr_len; i++) {
      let info = tmp_info_arr[i];
      let row_pri_val = info["a_ymd"] + "," + info["a_seq"];
      if (row_pri_val == opt_obj["todo_pri_val"]) {
        if (name == "a_time_sec" || name == "a_amount_num") {
          value = strFunc.uncomma(value);
        }

        tmp_info_arr[i][name] = value;

        //상태검사
        let row_per: any = TodoStateFunc.get_percent_by_todo_info(info);
        //a_state 상태(ready:준비,ing:하는중,stop:중지,complete:성공)
        let change_state = "";
        let change_is_success = "";
        if (row_per == 0) {
          change_state = "ready";
        } else if (row_per > 0) {
          change_state = "stop";
        }
        if (tmp_info_arr[i]["a_state"] == "stop") {
          change_state = "stop";
        }
        if (row_per >= 100) {
          change_state = "complete";
          change_is_success = "1";
        }

        tmp_info_arr[i]["a_state"] = change_state;
        tmp_info_arr[i]["a_is_success"] = change_is_success;
      }
    }
    setInfoArr(tmp_info_arr);
  };

  const on_delete_todo = (inData: any) => {
    let opt_obj = {
      todo_info: null,
      ...inData
    };
    if (strFunc.is_empty(opt_obj["todo_info"])) {
      alert("데이터가 없습니다.");
      return false;
    }
    if (!confirm("해당 플랜을 삭제 하시겠습니까?")) {
      return false;
    }

    let del_form_json = {
      "data_arr": [opt_obj["todo_info"]]
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/todo/todo/delete', del_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          //alert("삭제 되었습니다.");
          set_loading_data({
            is_display: true,
            text: "삭제 되었습니다.",
          });
          setTimeout(() => {
            set_loading_data({
              ...loading_data,
              is_display: false,
            });
          }, 600);
          myProps.list({});
          list({});
        } else {
          alert(response.data["msg"]);
          props.closePopup();
        }
      });

  };

  const add_new_todo_row_by_ajax=(inData:any)=>{
    let opt_obj={
      add_todo_arr:[],
      ...inData
    };
    if (opt_obj.add_todo_arr.length == 0) {
      alert("추가 할 데이터가 없습니다.");
      return false;
    }

    for(let i=0;i<opt_obj.add_todo_arr.length;i++){
      let item=opt_obj.add_todo_arr[i];
      if(strFunc.is_empty(item.a_title)){
        alert("제목이 없습니다.");
        return false;
      }
      if(strFunc.is_empty(item.a_stu_mcomp_user_seq)){
        alert("학생이 없습니다.");
        return false;
      }
      if(strFunc.is_empty(item.a_sort)){
        alert("분류가 없습니다.");
        return false;
      }
      if(strFunc.is_empty(item.a_subject)){
        alert("과목이 없습니다.");
        return false;
      }
      if(strFunc.is_empty(item.a_success_amount)){
        alert("개수가 없습니다.");
        return false;
      }
      if(strFunc.is_empty(item.a_par_mcomp_seq)){
        alert("학원키가 없습니다.");
        return false;
      }
    }

    let save_form_json = {
      "is_update": "",
      "data_arr": opt_obj.add_todo_arr,
      "is_default_val":"1",
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/todo/todo/write', save_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_loading_data({
            is_display: true,
            text: "저장 되었습니다.",
          });
          setTimeout(() => {
            set_loading_data({
              ...loading_data,
              is_display: false,
            });
          }, 600);
          set_add_todo_arr([]);
          list({});
          myProps.list({});
          // props.closePopup();
        } else {
          alert("저장 중 오류." + response.data["msg"]);
        }
      });
  };

  const save_todo_arr_by_ajax = () => {
    if (infoArr.length == 0) {
      alert("저장 할 데이터가 없습니다.");
      return false;
    }
    // if (!confirm("저장 하시겠습니까?")) {
    //   return false;
    // }

    let save_form_json = {
      "is_update": "1",
      "data_arr": infoArr,
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/todo/todo/write', save_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_loading_data({
            is_display: true,
            text: "저장 되었습니다.",
          });
          setTimeout(() => {
            set_loading_data({
              ...loading_data,
              is_display: false,
            });
          }, 600);
          list({});
          myProps.list({});
          // props.closePopup();
        } else {
          alert("저장 중 오류." + response.data["msg"]);
        }
      });
  };

  let tmp_start_date_json = DateFunc.get_date_json(new Date(list_opt["s_start_date"]));
  let pre_date_change_num = -1;
  if (tmp_start_date_json.day == 1) {
    //일요일이면 3일뒤로이동(금요일부터 보이게한다.)
    pre_date_change_num = -3;
  }
  let pre_date_str = DateFunc.get_date_format(DateFunc.get_change_date(new Date(list_opt["s_start_date"]), 'day', pre_date_change_num), "Y-m-d");

  let td_sort_data_json = TodoInfoArrFunc.get_td_sot_data_arr({
    info: {
      ...stu_info,
      todo_arr: infoArr,
    },
    base_date_str: list_opt["s_start_date"],
    pre_date_str: pre_date_str,
  });
  let td_sort_data_arr: any = [];
  for (let key in td_sort_data_json) {
    if (key == "homework" || key == "study") {
      td_sort_data_arr.push(td_sort_data_json[key]);
    } else {
      if (td_sort_data_json[key]["count"] > 0) {
        td_sort_data_arr.push(td_sort_data_json[key]);
      }
    }
  }

  return (
    <div style={{ marginBottom: 80 }}>
      <TopDateArea
        Style={Style}
        list_opt={list_opt}
        list={list}
      ></TopDateArea>
      <StuArea
        style={Style}
        stu_info={stu_info}
        td_sort_data_arr={td_sort_data_arr}
        list_opt={list_opt}
        list={list}
        open_stu_map_list_popup={open_stu_map_list_popup}
      ></StuArea>
      <div>
        {!strFunc.is_empty(list_opt.s_subject)&&
          <TextBookUsePageArea
            stu_seq={list_opt.s_stu_user_seq}
            subject_name={list_opt.s_subject}
            select_date={list_opt.s_start_date}
            refresh_data={()=>{
              myProps.list({});
            }}
          ></TextBookUsePageArea>
        }
        <TodoArea
          style={Style}
          user={user}
          stu_info={stu_info}
          select_date={list_opt.s_start_date}
          subject_name={list_opt.s_subject}
          callback={() => {
            list({});
            myProps.list({});
          }}
          td_sort_data_arr={td_sort_data_arr}
          on_change_todo={on_change_todo}
          on_delete_todo={on_delete_todo}
          add_todo_arr={add_todo_arr}
          set_add_todo_arr={set_add_todo_arr}
          add_new_todo_row_by_ajax={add_new_todo_row_by_ajax}
          openTodoWriteOnePopup={(inData: any) => {
            let opt_obj = {
              todo_info: {},
              isUpdate: true,
              todo_sort: "study",
              ...inData
            };
            let popup_opt_data = {
              select_date: list_opt.s_start_date,
              select_stu_name: stu_info.a_user_name,
              select_stu_seq: stu_info.a_seq,
              todo_info: opt_obj.todo_info,
              todo_sort: opt_obj["todo_sort"],
              isUpdate: opt_obj.isUpdate,
            };
            openTodoWriteOnePopup(popup_opt_data);
          }}
        ></TodoArea>
      </div>
      {!strFunc.is_empty(list_opt.s_subject) &&
        <div className="mt-2">
          <TodoDailyCArea
            stu_info={stu_info}
            set_stu_info={set_stu_info}
            subject_name={list_opt.s_subject}
            select_date={list_opt.s_start_date}
            callback_refresh={() => {
              list({});
              myProps.list({});
            }}
          ></TodoDailyCArea>
        </div>
      }
      <div className={Style.bottom_btn_area} >
        <button className="btn-l2 btn-yellowish2"
          style={{ width: 130, fontSize: "14px" }}
          onClick={() => { save_todo_arr_by_ajax(); }}>저장</button>
        <button className="btn-l2 btn-line-gray ml-4"
          style={{ width: 130, fontSize: "14px" }}
          onClick={() => { props.closePopup(); }}>닫기</button>
      </div>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} title_bar_style={{ borderBottom: 0 }}
          content_div_style={{ padding: "10px 0px" }} y={"0"}>
          {popupData.sort == "todo_write_one" &&
            <WriteTodoPopup
              stu_seq={popupData.select_stu_seq}
              stu_name={popupData.select_stu_name}
              select_date={popupData.select_date}
              rowData={popupData.todo_info}
              todo_sort={popupData.todo_sort}
              isUpdate={popupData.isUpdate}
              callback={(inData: any) => {
                list({});
                myProps.list({});
              }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></WriteTodoPopup>
          }
          {
            popupData.sort == "stu_map_list" &&
            <StuMapWritePopup
              stu_seq={stu_info.a_seq}
              stu_info_arr={[stu_info]}
              callback_refresh_data={(inData: any) => {
                list({});
                myProps.list({});
              }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></StuMapWritePopup>
          }
        </LayerPopup>
      }
      <LoadingComponent is_display={loading_data.is_display} text={loading_data.text}></LoadingComponent>
    </div>
  );
}

export default ViewTodoDaySortPopup;
